export const CertificatesListSGroups = ["certificate_read", "certificate_read_template_file", "app_file_read"];


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/utils/CertificatesListSGroups.js